module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-10-5543946d6da7be17db916d7b8be98c07.svg";